// extracted by mini-css-extract-plugin
export default {"customButton":"Button_customButton__WBxn0","enableButton":"Button_enableButton__rgjr8","disableButton":"Button_disableButton__7qwfP"};